"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2411],{

/***/ 94633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ ThumbnailNotReadyError; },
  "q": function() { return /* binding */ VideoApi; }
});

// EXTERNAL MODULE: ../next-utils/src/lib/HttpClient.ts
var HttpClient = __webpack_require__(74552);
// EXTERNAL MODULE: ../contracts/src/errors/AxiosResponseError.ts
var AxiosResponseError = __webpack_require__(86104);
;// CONCATENATED MODULE: ../contracts/src/media/thumbnail-type.enum.ts
var ThumbnailType;
(function(ThumbnailType) {
    ThumbnailType["STRIP"] = "strip";
    ThumbnailType["CUSTOM"] = "custom";
})(ThumbnailType || (ThumbnailType = {}));

;// CONCATENATED MODULE: ./modules/Api/Video/VideoApi.ts


class VideoApi {
    async createMediaVideo() {
        return this.client.post("/api/media/videos");
    }
    async getMyMediaData(id) {
        return this.client.get("/api/accounts/me/videos/".concat(id));
    }
    async getMediaData(idOrSlug) {
        return this.client.get("/api/media/videos/".concat(idOrSlug), {}, false);
    }
    async submitMedia(id, data) {
        return this.client.patch("/api/media/videos/".concat(id), data);
    }
    async getVideoUpload(id) {
        return this.client.get("/api/media/videos/".concat(id, "/upload"));
    }
    async createThumbnail(id) {
        return this.client.post("/api/media/videos/".concat(id, "/thumbnail"), {});
    }
    async putAttachmentToSignedUrl(signedUrl, file) {
        await this.client.put(signedUrl, file, {
            headers: {
                "Content-Type": ""
            }
        });
    }
    async updateThumbnail(videoId, thumbnailId) {
        return this.client.patch("/api/media/videos/".concat(videoId, "/thumbnail/").concat(thumbnailId), {}).catch((e)=>{
            if ((0,AxiosResponseError/* isAxiosResponseError */.G)(e) && e.response.status === 409) {
                throw new ThumbnailNotReadyError();
            }
            throw e;
        });
    }
    async createThumbnailFromStrip(id, index) {
        return this.client.post("/api/media/videos/".concat(id, "/thumbnail"), {
            type: ThumbnailType.STRIP,
            thumbstripIndex: index
        });
    }
    async getVideoStrips(id) {
        let size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 320;
        return this.client.get("/api/jwplayer/strips/".concat(id, "-").concat(size, ".vtt"), {
            headers: {
                "Content-Type": "text/html"
            }
        });
    }
    async publish(id) {
        return this.client.post("/api/media/videos/".concat(id, "/publish"), {});
    }
    async submit(id) {
        return this.client.post("/api/media/videos/".concat(id, "/submit"), {});
    }
    async delete(id) {
        return this.client.delete("/api/media/videos/".concat(id), {});
    }
    async toggleLike(id) {
        return this.client.put("/api/media/videos/".concat(id, "/like"));
    }
    async getPopularVideos(params) {
        return this.client.get("/api/media/videos/popular", {
            params
        }, false);
    }
    async getPopularCreators(params) {
        return this.client.get("/api/media/accounts/popular", {
            params
        }, false);
    }
    async getMapVideos(boundingBox, zoom) {
        return this.client.get("/api/map/videos", {
            params: {
                algoliaBB: boundingBox,
                superclusterBB: mapBoundsToSuperclusterBounds(boundingBox),
                zoom
            }
        }, false);
    }
    constructor(client = new HttpClient/* HttpClient */.e()){
        this.client = client;
    }
}
class ThumbnailNotReadyError extends Error {
}
function mapBoundsToSuperclusterBounds(boundingBox) {
    return [
        boundingBox[1],
        boundingBox[2],
        boundingBox[3],
        boundingBox[0]
    ];
}


/***/ }),

/***/ 8471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useResolveUserPublicProfilePagePath; }
/* harmony export */ });
/* harmony import */ var _Config_ConfigContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65729);

const useResolveUserPublicProfilePagePath = (userId)=>{
    const { pageUrl  } = (0,_Config_ConfigContext__WEBPACK_IMPORTED_MODULE_0__/* .useConfig */ .ZR)();
    return "".concat(pageUrl, "/users/").concat(userId);
};


/***/ }),

/***/ 10686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useResolveParkPagePath; }
/* harmony export */ });
/* harmony import */ var _Config_ConfigContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65729);

const useResolveParkPagePath = (slugOrId)=>{
    const { pageUrl  } = (0,_Config_ConfigContext__WEBPACK_IMPORTED_MODULE_0__/* .useConfig */ .ZR)();
    return "".concat(pageUrl, "/parks/").concat(slugOrId);
};


/***/ }),

/***/ 50853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ Share; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3862);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);



const DynamicShare = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 1798).then(__webpack_require__.bind(__webpack_require__, 1798)).then((mod)=>mod.DynamicShare), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(1798)
            ]
    },
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(1798)
            ]
    },
    suspense: false,
    ssr: false
});
function Share(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DynamicShare, {
        ...props
    });
}


/***/ }),

/***/ 48102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ SubscribeButton; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../ui/src/components/Button/Button.tsx
var Button = __webpack_require__(57100);
// EXTERNAL MODULE: ./modules/Auth/AuthContext.tsx
var AuthContext = __webpack_require__(35836);
// EXTERNAL MODULE: ./modules/Api/Account/AccountApi.ts
var AccountApi = __webpack_require__(74992);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.2.1_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(15265);
;// CONCATENATED MODULE: ./modules/User/hooks.ts


const useUser = ()=>{
    const userApi = new AccountApi/* AccountApi */.bP();
    const queryClient = (0,index_production.useQueryClient)();
    const useSubscribeAccountMutationQuery = function() {
        let { onSuccess , onError  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return (0,index_production.useMutation)((userId)=>userApi.subscribe(userId), {
            onSuccess,
            onError,
            onSettled: async ()=>{
                queryClient.invalidateQueries([
                    "subscriptions"
                ]);
                queryClient.invalidateQueries([
                    "userProfile"
                ]);
            }
        });
    };
    return {
        useSubscribeAccountMutationQuery
    };
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(83849);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./modules/User/SubscribeButton/SubscribeButton.tsx






const SubscribeButton = (param)=>{
    let { accountId , className , isSubscribed , onSuccess , button  } = param;
    const { useSession  } = (0,AuthContext/* useAuth */.a)();
    const { data  } = useSession();
    const { useSubscribeAccountMutationQuery  } = useUser();
    const { mutateAsync , isLoading  } = useSubscribeAccountMutationQuery({
        onSuccess
    });
    if (!data || data.user.cognito_id === accountId) return null;
    if (button) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: button({
            subscribe: mutateAsync,
            isLoading,
            isSubscribed
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
        disabled: isLoading,
        variant: "base",
        onClick: ()=>mutateAsync(accountId),
        className: classnames_default()({
            "bg-neutral-100": isSubscribed
        }, "!drop-shadow h-[40px] flex items-center !px-4 text-[14px]", className),
        children: isSubscribed ? "Subscribed" : "Subscribe"
    });
};


/***/ }),

/***/ 35715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ke": function() { return /* binding */ VideoModalProvider; },
/* harmony export */   "sw": function() { return /* binding */ useVideoModalContext; },
/* harmony export */   "xR": function() { return /* binding */ VideoModalConsumer; }
/* harmony export */ });
/* unused harmony export VideoModalContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51516);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_loop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58489);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88805);
/* harmony import */ var _parkschannel_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67731);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24900);







const VideoModalContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    nextVideo: null,
    previousVideo: null,
    selectedVideo: null,
    setSelectedVideoAndUrl: ()=>null,
    setSelectedVideo: ()=>null
});
const useVideoModalContext = ()=>(0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(VideoModalContext);
const VideoModalProvider = (param)=>{
    let { children , initialVideo  } = param;
    const { onModalOpen  } = (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .useAnalytics */ .z)();
    const [selectedVideo, setSelectedVideo] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialVideo !== null && initialVideo !== void 0 ? initialVideo : null);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { useVideoListQuery  } = (0,_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useVideo */ .R)();
    const { mapBounds , zoom  } = (0,_parkschannel_map__WEBPACK_IMPORTED_MODULE_5__/* .useMapBounds */ .R9)();
    const { data: videoList  } = useVideoListQuery(mapBounds, zoom);
    const handleChangeVideo = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((video)=>{
        setSelectedVideo(video);
        if (video && video.title) {
            onModalOpen("videoModal", {
                video_id: video.id,
                video_title: video.title
            });
        }
    }, []);
    const handleChangeVideoAndUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((video)=>{
        handleChangeVideo(video);
        void router.push({
            query: {
                slug: video === null || video === void 0 ? void 0 : video.slug
            }
        }, undefined, {
            shallow: false
        });
    }, []);
    const nextVideo = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return videoList && (0,_utils_loop__WEBPACK_IMPORTED_MODULE_6__/* .next */ .lp)(videoList.videos, selectedVideo, (currentItem, otherItem)=>{
            return (currentItem === null || currentItem === void 0 ? void 0 : currentItem.id) === (otherItem === null || otherItem === void 0 ? void 0 : otherItem.id);
        });
    }, [
        selectedVideo,
        videoList
    ]);
    const previousVideo = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return videoList && (0,_utils_loop__WEBPACK_IMPORTED_MODULE_6__/* .previous */ .Xp)(videoList.videos, selectedVideo, (currentItem, otherItem)=>{
            return (currentItem === null || currentItem === void 0 ? void 0 : currentItem.id) === (otherItem === null || otherItem === void 0 ? void 0 : otherItem.id);
        });
    }, [
        selectedVideo,
        videoList
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VideoModalContext.Provider, {
        value: {
            selectedVideo,
            setSelectedVideo: handleChangeVideo,
            setSelectedVideoAndUrl: handleChangeVideoAndUrl,
            nextVideo: nextVideo,
            previousVideo: previousVideo
        },
        children: children
    });
};
const VideoModalConsumer = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VideoModalContext.Consumer, {
        children: (value)=>children(value)
    });
};


/***/ }),

/***/ 88805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useVideo; }
/* harmony export */ });
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94633);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15265);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__);


const useVideo = ()=>{
    const videoApi = new _Api__WEBPACK_IMPORTED_MODULE_0__/* .VideoApi */ .q();
    const useVideoListQuery = (boundingBox, zoom)=>{
        const { data , ...rest } = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([
            "videos",
            "map",
            boundingBox,
            zoom
        ], async ()=>await videoApi.getMapVideos(boundingBox, zoom), {
            keepPreviousData: true,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            enabled: Array.isArray(boundingBox)
        });
        const onlyProperties = ((data === null || data === void 0 ? void 0 : data.clusters) || []).map((point)=>point.properties);
        return {
            data: {
                videos: onlyProperties,
                videosCount: (data === null || data === void 0 ? void 0 : data.videosCount) || 0
            },
            ...rest
        };
    };
    const useGetVideoQuery = (idOrSlug)=>(0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([
            "videos",
            idOrSlug
        ], async ()=>await videoApi.getMediaData(idOrSlug), {
            refetchOnMount: false,
            enabled: !!idOrSlug
        });
    return {
        useVideoListQuery,
        useGetVideoQuery
    };
};


/***/ }),

/***/ 58489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PQ": function() { return /* binding */ takeNextLooped; },
/* harmony export */   "Xp": function() { return /* binding */ previous; },
/* harmony export */   "lp": function() { return /* binding */ next; }
/* harmony export */ });
function next(arr, currentItem, compareFn) {
    if (arr.length <= 1) return null;
    const currentItemIndex = arr.findIndex((item)=>compareFn(item, currentItem));
    if (currentItemIndex === -1) return null;
    const nextItemIndex = currentItemIndex === arr.length - 1 ? 0 : currentItemIndex + 1;
    return arr[nextItemIndex];
}
function previous(arr, currentItem, compareFn) {
    if (arr.length <= 1) return null;
    const currentItemIndex = arr.findIndex((item)=>compareFn(item, currentItem));
    if (currentItemIndex === -1) return null;
    const previousItemIndex = currentItemIndex === 0 ? arr.length - 1 : currentItemIndex - 1;
    return arr[previousItemIndex];
}
function takeNextLooped(arr, currentItem, compareFn) {
    let length = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
    if (arr.length <= 1) return [];
    const currentItemIndex = arr.findIndex((item)=>compareFn(item, currentItem));
    if (currentItemIndex === -1) return [];
    const nextItems = [];
    let nextItemIndex = currentItemIndex;
    for(let itemsCount = 0; itemsCount < length; itemsCount++){
        nextItemIndex = nextItemIndex === arr.length - 1 ? 0 : nextItemIndex + 1;
        if (nextItemIndex === currentItemIndex) break;
        nextItems.push(arr[nextItemIndex]);
    }
    return nextItems;
}


/***/ }),

/***/ 76356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useButtonsAnalytics; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _useAnalytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24900);


const useButtonsAnalytics = ()=>{
    const { onButtonClick  } = (0,_useAnalytics__WEBPACK_IMPORTED_MODULE_1__/* .useAnalytics */ .z)();
    const listenEvent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((e)=>{
        if (!e || !e.target) return;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        onButtonClick(e.target.textContent);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!document) return;
        const buttons = document.querySelectorAll("button");
        buttons.forEach((button)=>button.addEventListener("click", listenEvent));
        return ()=>{
            buttons.forEach((button)=>button.removeEventListener("click", listenEvent));
        };
    }, []);
};


/***/ }),

/***/ 86104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ isAxiosResponseError; }
/* harmony export */ });
function isAxiosResponseError(error) {
    return typeof error === "object" && error !== null && "response" in error;
}


/***/ }),

/***/ 67731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PL": function() { return /* binding */ MapBoundsProvider; },
  "R9": function() { return /* binding */ useMapBounds; }
});

// UNUSED EXPORTS: MapBoundsContext

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
;// CONCATENATED MODULE: ../map/src/Map/useDebounce.ts

function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0,react.useState)(value);
    (0,react.useEffect)(()=>{
        const handler = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay);
        return ()=>{
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}

;// CONCATENATED MODULE: ../map/src/Map/MapBoundsContext.tsx



const MapBoundsContext = /*#__PURE__*/ (0,react.createContext)({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setMapBounds: ()=>{},
    mapBounds: null,
    zoom: 3,
    setZoom: ()=>null
});
const useSimpleMapBounds = ()=>{
    return (0,react.useContext)(MapBoundsContext);
};
const useMapBounds = ()=>{
    const { mapBounds , zoom , ...rest } = useSimpleMapBounds();
    const debouncedMapBounds = useDebounce(mapBounds, 100);
    const debouncedZoom = useDebounce(zoom, 100);
    return {
        mapBounds: debouncedMapBounds,
        superclusterBounds: mapBoundsToSuperclusterBounds(debouncedMapBounds),
        roundedBounds: roundBounds(debouncedMapBounds),
        zoom: debouncedZoom,
        ...rest
    };
};
const MapBoundsProvider = (param)=>{
    let { children , defaultBounds , defaultZoom  } = param;
    const [zoom, setZoom] = (0,react.useState)(defaultZoom);
    const [mapBounds, setMapBounds] = (0,react.useState)(defaultBounds);
    const handleSetMapBounds = (0,react.useCallback)((bounds)=>{
        setMapBounds(bounds);
    }, []);
    const handleSetMZoom = (0,react.useCallback)((z)=>{
        setZoom(z);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MapBoundsContext.Provider, {
        value: {
            mapBounds,
            setMapBounds: handleSetMapBounds,
            zoom,
            setZoom: handleSetMZoom
        },
        children: children
    });
};
function mapBoundsToSuperclusterBounds(boundingBox) {
    if (!boundingBox) return boundingBox;
    return [
        boundingBox[1],
        boundingBox[2],
        boundingBox[3],
        boundingBox[0]
    ];
}
function roundBounds(boundingBox) {
    if (!boundingBox) return boundingBox;
    return [
        Math.ceil(boundingBox[0]),
        Math.floor(boundingBox[1]),
        Math.floor(boundingBox[2]),
        Math.ceil(boundingBox[3])
    ];
}


/***/ }),

/***/ 14927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ItemsList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



function ItemsList(param) {
    let { items , renderItem , className , liClassName , noItemsMessage ="Not found" , noItemsClassName  } = param;
    if (items.length === 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("font-medium text-sm text-neutral-900 my-5 text-center block", noItemsClassName),
            children: noItemsMessage
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className),
        children: items.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-full", liClassName),
                children: renderItem(item)
            }, item.id))
    });
}


/***/ }),

/***/ 88044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Modal; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/components/transitions/transition.js + 3 modules
var transition = __webpack_require__(49236);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/components/dialog/dialog.js + 10 modules
var dialog = __webpack_require__(81231);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@heroicons+react@1.0.6_react@18.2.0/node_modules/@heroicons/react/outline/esm/XIcon.js
var XIcon = __webpack_require__(54109);
// EXTERNAL MODULE: ../../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(83849);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../ui/src/components/CloseButton/CloseButton.tsx




const CloseButton = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { onClick , className  } = param;
    return (0,jsx_runtime.jsx)("button", {
        type: "button",
        className: classnames_default()("flex items-center justify-center h-10 w-10 rounded-full focus:outline-none", className),
        onClick: onClick,
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(XIcon/* default */.Z, {
            className: "h-5 w-5",
            "aria-hidden": "true"
        })
    });
});

;// CONCATENATED MODULE: ../ui/src/components/Modal/Modal.tsx





const Modal = (param)=>{
    let { children , isOpen , setIsOpen , testId , title , contentClassName , closeOnOutside =true , exitButton  } = param;
    const cancelButtonRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
        show: isOpen,
        as: react.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
            as: "div",
            className: "relative z-[100]",
            initialFocus: cancelButtonRef,
            onClose: ()=>closeOnOutside ? setIsOpen(false) : null,
            "data-testid": testId,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                    as: react.Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed inset-0 bg-black bg-opacity-90 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fixed z-10 inset-0 overflow-y-auto lg:p-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-center min-h-full text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                            as: react.Fragment,
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog.Panel */.V.Panel, {
                                className: classnames_default()("relative bg-white px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all  sm:p-6 flex flex-col w-full lg:rounded-2xl ", contentClassName),
                                children: [
                                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()("pb-4"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "font-bold text-lg text-neutral-700 mt-1",
                                            children: title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute top-4 right-4 z-50",
                                        children: exitButton ? exitButton(()=>setIsOpen(false), cancelButtonRef) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                                            onClick: ()=>setIsOpen(false),
                                            ref: cancelButtonRef
                                        })
                                    }),
                                    children
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 90202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ Tag; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59785);




const Tag = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)((param)=>{
    let { id , value , size ="sm" , color ="transparent" , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
        variant: "bodySmall",
        id: id,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("normal-case rounded-full text-neutral-700 inline-block font-medium whitespace-nowrap", tagSize(size), tagColor(color), className),
        children: typeof value === "string" ? capitalizeFirstLetter(value) : value
    });
});
function tagSize(size) {
    switch(size){
        case "sm":
            return "py-1 px-2";
        default:
            return "py-2 px-4";
    }
}
function tagColor(color) {
    switch(color){
        case "orange":
            return "bg-orange1";
        case "yellow":
            return "bg-yellow1";
        case "transparent":
            return "bg-transparent";
        case "gray":
            return "bg-neutral-100";
        case "darkGray":
            return "bg-neutral-200";
        case "light":
            return "bg-white";
        default:
            return "bg-".concat(color);
    }
}
function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}


/***/ }),

/***/ 71740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ArrowRight; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const ArrowRight = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        className: className,
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M17 8L21 12M21 12L17 16M21 12H3",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


/***/ }),

/***/ 49811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ LocationMarkerIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const LocationMarkerIcon = (param)=>/*#__PURE__*/ {
    let { className , color ="yellow"  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.03982 3.23999C5.09008 2.18973 6.51453 1.5997 7.99982 1.5997C9.48511 1.5997 10.9096 2.18973 11.9598 3.23999C13.0101 4.29024 13.6001 5.7147 13.6001 7.19999C13.6001 8.68527 13.0101 10.1097 11.9598 11.16L7.99982 15.12L4.03982 11.16C3.51975 10.64 3.10721 10.0226 2.82574 9.34315C2.54428 8.66368 2.39941 7.93544 2.39941 7.19999C2.39941 6.46454 2.54428 5.73629 2.82574 5.05683C3.10721 4.37737 3.51975 3.76 4.03982 3.23999ZM7.99982 8.79999C8.42416 8.79999 8.83113 8.63141 9.13119 8.33136C9.43125 8.0313 9.59982 7.62433 9.59982 7.19999C9.59982 6.77564 9.43125 6.36867 9.13119 6.06862C8.83113 5.76856 8.42416 5.59999 7.99982 5.59999C7.57547 5.59999 7.16851 5.76856 6.86845 6.06862C6.56839 6.36867 6.39982 6.77564 6.39982 7.19999C6.39982 7.62433 6.56839 8.0313 6.86845 8.33136C7.16851 8.63141 7.57547 8.79999 7.99982 8.79999Z",
                fill: "url(#".concat(color, "-paint-id)")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                    id: "".concat(color, "-paint-id"),
                    x1: "7.99976",
                    y1: "1.5997",
                    x2: "7.99976",
                    y2: "15.12",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            stopColor: color === "orange" ? "#FFF064" : "#FDF28A"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "1",
                            stopColor: color === "orange" ? "#FF8A00" : "#FFC700"
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 35368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ ShareIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const ShareIcon = (param)=>/*#__PURE__*/ {
    let { className  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.78875 8.89446C5.92342 8.62514 5.99942 8.32116 5.99942 7.99985C5.99942 7.67854 5.92342 7.37456 5.78875 7.10524M5.78875 8.89446C5.58722 9.29736 5.25555 9.62042 4.84748 9.81131C4.43941 10.0022 3.97883 10.0497 3.54037 9.94619C3.10191 9.84266 2.71125 9.59414 2.43168 9.24088C2.15211 8.88763 2 8.45034 2 7.99985C2 7.54936 2.15211 7.11207 2.43168 6.75882C2.71125 6.40556 3.10191 6.15704 3.54037 6.05351C3.97883 5.94998 4.43941 5.99751 4.84748 6.18839C5.25555 6.37928 5.58722 6.70234 5.78875 7.10524M5.78875 8.89446L10.2101 11.105M5.78875 7.10524L10.2101 4.89472M10.2101 11.105C9.97283 11.5795 9.93379 12.1289 10.1016 12.6322C10.2694 13.1355 10.6302 13.5515 11.1048 13.7888C11.5793 14.0261 12.1287 14.0651 12.6321 13.8973C13.1354 13.7296 13.5515 13.3687 13.7888 12.8942C14.0261 12.4197 14.0651 11.8703 13.8973 11.367C13.7296 10.8637 13.3687 10.4476 12.8941 10.2104C12.6591 10.0929 12.4033 10.0228 12.1413 10.0042C11.8792 9.9856 11.6161 10.0188 11.3668 10.1018C10.8635 10.2696 10.4474 10.6305 10.2101 11.105ZM10.2101 4.89472C10.3276 5.12964 10.4902 5.33912 10.6887 5.5112C10.8871 5.68328 11.1175 5.81458 11.3667 5.89763C11.6159 5.98067 11.8791 6.01381 12.1411 5.99518C12.4031 5.97654 12.6589 5.90648 12.8938 5.78899C13.1287 5.67151 13.3382 5.50891 13.5103 5.31047C13.6824 5.11203 13.8137 4.88164 13.8968 4.63246C13.9798 4.38327 14.013 4.12017 13.9943 3.85818C13.9757 3.59618 13.9056 3.34042 13.7881 3.1055C13.5508 2.63106 13.1348 2.2703 12.6315 2.10259C12.1282 1.93488 11.5789 1.97396 11.1044 2.21123C10.63 2.44849 10.2692 2.86451 10.1015 3.36776C9.93375 3.87101 9.97283 4.42028 10.2101 4.89472Z",
            stroke: "currentColor",
            strokeWidth: "1.3",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


/***/ })

}]);